import { Component, inject, ViewEncapsulation } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle
} from '@angular/material/dialog';
import { MatButton } from '@angular/material/button';
import { DialogActionType, DialogConfig } from '../dialog-types';

@Component({
  selector: 'lfe-confirm-dialog',
  standalone: true,
  imports: [MatDialogTitle, MatDialogContent, MatDialogActions, MatButton],
  templateUrl: './confirm-dialog.component.html',
  styleUrl: './confirm-dialog.component.css',
  encapsulation: ViewEncapsulation.None
})
export class ConfirmDialogComponent {
  private readonly dialogRef = inject(MatDialogRef<ConfirmDialogComponent>);
  readonly data: DialogConfig = inject(MAT_DIALOG_DATA);

  onActionClick(action: DialogActionType): void {
    this.dialogRef.close(action);
  }
}
